module.exports = __webpack_public_path__ + "static/media/RA-newlogo.72dc3413.png";